export { copyToClipboard }

const copyToClipboard = async (text: string) => {
  let copied = false

  try {
    await navigator.clipboard.writeText(text)
    copied = true
  } catch {
    // fail silently
  }

  return copied
}
